<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="search">
        <div class="form-search__row">
          <div class="form-search__single">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Account ID or Member Bank Account Number"
              v-model="formData.q"
            />
          </div>
        </div>
        <div class="form-search__action">
          <div class="w-3/12 flex">
            <BaseButton type="submit" class="mr-2" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton type="button" buttonClass="default" @click="reset"
              >Reset Search</BaseButton
            >
          </div>
        </div>
      </form>

      <p class="text-sm text-red-500 mb-2 font-medium">
        Note: Only bank accounts with complete data can be migrated.
      </p>

      <div class="main-table-wrap">
        <table class="main-table">
          <thead v-if="!loading">
            <tr>
              <th>Account Holder</th>
              <th>Account Number</th>
              <th>Asset</th>
              <th>Usage</th>
              <th>Owner</th>
              <th>Category</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="table__loader" colspan="8" v-if="loading">
                Please wait
                <font-awesome-icon
                  :icon="['fas', 'spinner']"
                  spin
                  class="ml-2"
                />
              </td>
            </tr>
            <tr v-if="results.length <= 0 && !loading">
              <td class="text-center pt-6" colspan="8">No data found.</td>
            </tr>
            <tr v-for="row in results" :key="row.int_memberId">
              <td>{{ row.vch_bankaccountName }}</td>
              <td>{{ row.bank_type + " - " + row.vch_bankaccountNumber }}</td>
              <td>{{ row.assetName ? row.assetName : "-" }}</td>
              <td>{{ row.bank_usage ? row.bank_usage : "-" }}</td>
              <td>{{ row.bank_owner ? row.bank_owner : "-" }}</td>
              <td>{{ row.bank_category ? row.bank_category : "-" }}</td>
              <td>
                {{ row.int_bankaccountBlock == 1 ? "Blocked" : "Available" }}
              </td>
              <td>
                <button
                  type="button"
                  class="w-full border-green-500 button border border-solid hover:bg-green-500 hover:text-white transition-all duration-200 my-2 text-center text-green-500"
                  @click="migrate(row.int_bankaccountId)"
                >
                  <font-awesome-icon :icon="['fas', 'exchange-alt']" />
                  Migrate
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";

export default {
  mixins: [showListMixin],
  methods: {
    migrate(memberId) {
      this.$store.commit("toggleLoading");

      this.$http({
        method: "patch",
        url: process.env.VUE_APP_API_URL + this.$route.path + "/" + memberId,
      })
        .then((res) => {
          this.$swal({
            title: res.data.title,
            text: res.data.message,
            icon: res.data.icon,
          });
        })
        .catch(() => {
          this.$swal({
            title: "Whoops!",
            text: "An error has occurred. Please contact the system admin.",
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.commit("toggleLoading");
        });
    },
    fetchData() {
      (this.results = []), (this.loading = true);

      this.queryString = this.parseQueryString(this.$route.query);

      if (!this.queryString) {
        this.reset();
      } else {
        this.formData = this.$route.query;
      }

      this.formData.ts = new Date().getTime();

      this.$http
        .get(process.env.VUE_APP_API_URL + this.$route.path + this.queryString)
        .then((res) => {
          if (res.status == 200) {
            this.loading = false;

            const response = res.data;

            if (response) {
              this.results = response;

              this.pagingData.currentPage = response.current_page;
              this.pagingData.lastPage = response.last_page;
              this.pagingData.from = response.from;
              this.pagingData.to = response.to;
              this.pagingData.total = response.total;
            }
          }
        })
        .finally(() => {});
    },
  },
};
</script>
